import React, { useCallback, useEffect, useRef, useState } from "react"
import { BackHandler, Platform, SafeAreaView, View } from "react-native"
import CheckInGuide from "./checkInGuide";
import Loader from "../../components/Loader/loader";
import FetchingDataScreen from "../../components/fetchingDataScreen";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import BookingInfo from "./bookingInfo";
import VerifyIdentity from "./idVerification/verifyIdentity";
import { AdditionalDetails } from "./additionalDetails";
import PreCheckInSuccess from "./preCheckInSuccess";
import CheckInSuccess from "./checkInSuccess";
import { setGoHome } from "../../Redux/Reducers/appConfigReducer";
import { getDataLoadingScreen } from "../../js/getDataLoadingScreen";
import { checkBookingStatus, fetchCheckInConfigs, fetchPreCheckinForm, getAccompanyguestDynamicBookingForm, getCountryList, getDisclaimerText, getDocumentList, preCheckInSuccessHandler } from "../../Redux/Actions/checkInAction";
import { CHECKIN_DEMO_FLOW, CLICKED, clientConfigPath, current_client_config, currentIP, DEMO_FLOW_ENABLED, EXIT, GLOBAL_IV, GLOBAL_SALT, INITIAL_LOADER_SCREEN, MOBILE_CHECKIN_CATEGORY, PRE_CHECKIN } from "../../config/Constant";
import { useTranslation } from "react-i18next";
import { convertBase64ToBinary, convertImageToBinaryBlob, convertPathToBase64 } from "../../js/parseImageData/parseImageData";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { linkToRoom } from "../../Redux/Actions/roomLinkingAction";
import { calculateTimeDifference, generateToken, isWeb } from "../../utils/Helper";
import { AesUtil } from "../../js/AesUtil";
import { setPreCheckInStatus } from "../../Redux/Reducers/checkInReducer";
import InfoPopupModal from "../../components/infoPopupModal";
import { CardValidation } from "./cardValidation/cardValidation";
import { sendAnalytics } from "../../Redux/Actions/analyticsAction";
import { setProceedLoginToTheApp } from "../../Redux/Actions/appConfigAction";
import { useFocusEffect, useRoute } from "@react-navigation/native";
import AccompanyGuestDetails from "./accompanyGuests/accompanyGuestDetails";
import AccompanyingGuestDetailsInput from "./accompanyGuests/accompanyGuestInput";
import Disclaimer from "./disclaimer/disclaimer";
import FadeTransition from "../../components/fadeTransition";
import { AdhocPage } from "../adhoc";
import { BEFORE_PRE_CHECK_IN } from "../../Redux/Actions/adhocAction";



export const CHECKIN_GUIDE = "CHECKIN_GUIDE";
export const BOOKING_INFO = 'BOOKING_INFO'
export const ID_VERIFICATION = "ID_VERIFICATION";
export const ACCOMPANY_GUEST_ID_VERIFICATION = "ACCOMPANY_GUEST_ID_VERIFICATION";
export const CARD_VALIDATION = 'CARD_VALIDATION';
export const ADDITION_DETAILS = "ADDITION_DETAILS";
export const ACCOMPANY_GUEST_DETAILS = "ACCOMPANY_GUEST_DETAILS";
export const DISCLAIMER = "DISCLAIMER";

export const CheckIn = () => {

    const dispatch = useDispatch();
    const { t } = useTranslation();
    const route = useRoute();


    let aesUtil = new AesUtil(128, 1000);

    const [widgetLaunchTime, setWidgetLaunchTime] = useState(() => new Date());
    const [checkinSessionToken, setCheckinSessionToken] = useState(() => route?.params?.widgetSessionId ?? generateToken("checkin_"));
    
    const { currentWidget } = useSelector((state) => state.deviceConfigSlice);

    const { isLoggedIn } = useSelector((state) => state.appConfigSlice);
    const { innspireOneConfigs } = useSelector((state) => state.appPreservedConfigSlice);
    const { mobileCheckInConfigs } = useSelector(state => state.deviceConfigSlice.webAppWidgetsInfo) || {};
    const { supportedCardValidationFlow, supportedAccompanyGuestFlow } = useSelector(state => state.checkInSlice);
    const { preCheckInWidgetState } = useSelector(state => state.checkInSlice);
    const { preCheckInCompleted, preCheckInData } = useSelector(state => state.checkInSlice.preCheckInStatus);

    const { adhocWidgetData } = useSelector(
        state => ({
            adhocWidgetData: state.adhocSlice.adhocWidgetData
        }),
        shallowEqual
    );
    const adhocDataList = adhocWidgetData?.[BEFORE_PRE_CHECK_IN] || [];
    const [showAdhocItem, setShowAdhocItem] = useState({
        renderAdhoc: false,
        isAdhocShown: false
    });

    const { isBookingFound, bookingData } = useSelector(state => state.checkInSlice.bookingStatus);

    const [isCheckInSuccess, setIsCheckInSuccess] = useState({
        status: false,
        guestDetails: {
            lastName: "",
            confirmationNumber: "",
            checkinDate: "",
            roomNumber: ""
        }
    });


    const [initialLoder, setInitialLoader] = useState(false);
    const [preCheckinFormData, setPreCheckInFormData] = useState([]);
    const [isConfirmationNumberMandatory, setIsConfirmationNumberMandatory] = useState(false);

    const [loaderState, setLoaderState] = useState({
        isVisible: false,
        message: ""
    });
    const [fetchApiError, setFetchApiError] = useState({
        errorStatus: false,
        errorMessage: "",
        onContinueFunc: null,
        primaryBtnLabel: "",
        onCloseFunc: null,
        secondaryBtnLabel: ""
    });

    const [currentPage, setCurrentPage] = useState(CHECKIN_GUIDE)
    const currentPageRef = useRef(currentPage);


    const [checkInConfigLocalCopy, setCheckInConfigLocalCopy] = useState({

        isPreCheckFlow: false,

        guestValidationMaxRetry: 2,
        idValidationInterface: "default",
        disableLivelinessCheck: false,

        guestImagesCheckEnabled: false,
        showAccompanyGuestIDPage: false,

        cardValidationEnabled: false,
        cardValidationInterface: "",
        showCardValidation: false,

        accompanyGuestApproach: "",
        showAccompanyGuestDetailsPage: false,

        showDisclaimer: false,
        skipGuideScreen: false,
    })

    const [guestdetails, setGuestDetails] = useState(({
        bookingFoundLocalVar: false,
        guestName: "",
        lastName: "",
        confirmationNumber: "",
        reservationNumber: "",
        checkinDate: "",
        accompanyGuestData: [],
        checkInTime: "",
        idDetails: null,
        address: {
            addressLine1: "",
            addressLine2: "",
            city: "",
            state: "",
            postalCode: "",
            country: ""
        },
        email: "",
        phone: "",
        birthDate: "",
        extraData: ""
    }))

    const [accompanyGuestDetailsFormData, setAccompanyGuestDetailsFormData] = useState([]);


    const [isIdVerificationCompleted, setIsIdVerificationCompleted] = useState(false);
    const [idVerificationMediaFiles, setIdVerificationMediaFiles] = useState({
        selectedIdType: {},
        idImageUri: "",
        idImageBackUri: "",
        idImagesInfo: {},
        selfieUri: "",
        selfieImagesInfo: {},
    })

    const [isCardVerified, setIsCardVerified] = useState(false);


    const [earlyCheckInConfig, setEarlyCheckInConfig] = useState({
        askEarlyCheckIn: false,
        message: "",
        doEarlyCheckIn: false,
    })

    const [disclaimerObj, setDisclaimerObj] = useState({
        isDisclaimerAccepted: false,
        disclaimerText: "",
        langCode: "",
        disclaimerType: "generalDisclaimer",
    });

    const [cancel, setCancel] = useState(false)

    const [proceedToCheckIn, setProceedToCheckIn] = useState(false);

    const updateGuestDetails = (details) => {
        setGuestDetails(prevState => ({
            ...prevState,
            ...details
        }));
    }


    const updateCheckInConfigLocalCopy = (configs) => {
        setCheckInConfigLocalCopy(prevState => ({
            ...prevState,
            ...configs
        }));
    };

    const updateEarlyCheckInConfig = (configs) => {
        setEarlyCheckInConfig(prevState => ({
            ...prevState,
            ...configs
        }));
    }

    const updateDisclaimerObj = (obj) => {
        setDisclaimerObj(prevState => ({
            ...prevState,
            ...obj
        }));
    }
    const updateAdhochShown = (obj) => {
        setShowAdhocItem(prevState => ({
            ...prevState,
            ...obj
        }));
    }

    const updateLoaderState = (state, msg) => {
        if (state) {
            setLoaderState({ isVisible: true, message: msg });
        } else {
            setLoaderState({ isVisible: false, message: "" });
        }
    }

    const updateFetchApiError = (errorStatus, errorMessage, onContinueFunc=null, primaryBtnLabel, onCloseFunc=null, secondaryBtnLabel) => {
        setFetchApiError({
            errorStatus,
            errorMessage: errorStatus ? errorMessage : "",
            onContinueFunc: errorStatus ? onContinueFunc : null,
            primaryBtnLabel: errorStatus ? primaryBtnLabel : "",
            onCloseFunc: errorStatus ? onCloseFunc : null,
            secondaryBtnLabel: errorStatus ? secondaryBtnLabel : ""
        });
    }



    const checkInSuccessHandler = (roomNumber) => {
        AsyncStorage.setItem("VerifiedUser", "true");
        setIsCheckInSuccess({ status: true, guestDetails: { lastName: guestdetails.lastName, confirmationNumber: guestdetails.confirmationNumber, checkinDate: guestdetails.checkinDate, roomNumber: roomNumber } })
    }


    const checkInHandler = async () => {

        if (DEMO_FLOW_ENABLED || CHECKIN_DEMO_FLOW) {
            if(guestdetails?.roomNumber){
                await AsyncStorage.setItem('doorkeyValidation', "true");
                checkInSuccessHandler(guestdetails?.roomNumber);
            } else {
                updateFetchApiError(true, "Room Number not found with the given booking");
            }
            return;
        }


        try {
            updateLoaderState(true, "Processing your check-in...");

            const sessionToken = await AsyncStorage.getItem("sessionToken");
            const checkInDataPayload = {...guestdetails, "isEarlyCheckIn": earlyCheckInConfig.doEarlyCheckIn};

            // API call
            const response = await clientConfigPath.post("/mobileCheckIn/checkInGuest", {
                header: { sessionToken, actionKey: "doCheckIn" },
                payload: checkInDataPayload,
            }, { timeout: 40000 });


            if (response.data.payload.roomNumber) {
                await AsyncStorage.setItem('doorkeyValidation', "true");
                checkInSuccessHandler(response.data.payload.roomNumber);
                dispatch(sendAnalytics(MOBILE_CHECKIN_CATEGORY, "CHECK-IN - SUCCESS", { "element": "widget", "widgetSessionId": checkinSessionToken, "pageName": currentPage }));
            } else {
                const errorMessage = response?.data?.header?.status?.msg || "Something went wrong";
                updateFetchApiError(true, errorMessage);
                dispatch(sendAnalytics(MOBILE_CHECKIN_CATEGORY, "CHECK-IN - FAILED", { "element": "widget", "widgetSessionId": checkinSessionToken, "pageName": currentPage, "errorMessage": errorMessage }));
            }
        } catch (error) {
            // Consolidated error handling
            const defaultMessage = "Something went wrong";
            const errorMessage = error?.response?.data?.header?.status?.msg || defaultMessage;
            updateFetchApiError(true, errorMessage);
            dispatch(sendAnalytics(MOBILE_CHECKIN_CATEGORY, "CHECK-IN - FAILED", { "element": "widget", "widgetSessionId": checkinSessionToken, "pageName": currentPage, "errorMessage": errorMessage }));
        } finally {
            updateLoaderState(false);
            updateEarlyCheckInConfig({doEarlyCheckIn: false});
        }
    };




    const preCheckInHandler = async () => {

        if (DEMO_FLOW_ENABLED || CHECKIN_DEMO_FLOW) {
            await AsyncStorage.setItem('doorkeyValidation', "true");
            dispatch(preCheckInSuccessHandler({...guestdetails}, true));
            return;
        }


        try {
            updateLoaderState(true, "Updating your details...");

            const sessionToken = await AsyncStorage.getItem("sessionToken");
            const preCheckInDataPayload = {...guestdetails};

            // API call
            const response = await clientConfigPath.post("/mobileCheckIn/preCheckInGuest", {
                header: { sessionToken, actionKey: "doPreCheckIn" },
                payload: preCheckInDataPayload,
            }, { timeout: 40000 });
            await AsyncStorage.setItem('doorkeyValidation', "true");
            dispatch(preCheckInSuccessHandler(preCheckInDataPayload, true));
            dispatch(sendAnalytics(MOBILE_CHECKIN_CATEGORY, "PRE CHECK-IN - SUCCESS", { "element": "widget", "widgetSessionId": checkinSessionToken, "pageName": currentPage }));
        } catch (error) {
            // Consolidated error handling
            const defaultMessage = "Something went wrong";
            const errorMessage = error?.response?.data?.header?.status?.msg || defaultMessage;
            updateFetchApiError(true, errorMessage);
            dispatch(sendAnalytics(MOBILE_CHECKIN_CATEGORY, "PRE CHECK-IN - FAILED", { "element": "widget", "widgetSessionId": checkinSessionToken, "pageName": currentPage, "errorMessage": errorMessage }));
        } finally {
            updateLoaderState(false);
        }
    };


    const handleProceedToCheckin = async () => {

        const bookingCacheStatus = await initiateBookingCache();

        if (bookingCacheStatus?.status == "SUCCESS") {
            
            if (preCheckInWidgetState == PRE_CHECKIN) {
                preCheckInHandler();
            } else {
                checkInHandler()
            }

        } else if (!bookingCacheStatus?.status || bookingCacheStatus?.status == "FAILURE"){
            updateFetchApiError(true, bookingCacheStatus.message || "Something went wrong");
        }

    }


    useEffect(() => {
        if (proceedToCheckIn) {
            setProceedToCheckIn(false);

            if(checkInConfigLocalCopy.showDisclaimer && !disclaimerObj.isDisclaimerAccepted) {
                handleDisclaimerText();
                return;
            }
            if(adhocDataList?.length && !showAdhocItem.isAdhocShown){
                updateAdhochShown({
                    renderAdhoc: true,
                    isAdhocShown: true
                });
                return
            }

            handleProceedToCheckin();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [proceedToCheckIn])




    useEffect(() => {
        currentPageRef.current = currentPage;
      }, [currentPage]);

    const handleNextPage = (currentPageName_localvar = null) => {


        let currentPageName = typeof currentPageName_localvar === "string" ? currentPageName_localvar : currentPage;

        console.log("handleNextPage called from:", currentPageName);

        switch (currentPageName) {
            case CHECKIN_GUIDE:
                isBookingFound ? handleNextPage(BOOKING_INFO) : setCurrentPage(BOOKING_INFO);
                break;
            case BOOKING_INFO:
                updateAdhochShown({ isAdhocShown: false, renderAdhoc: false });
                updateDisclaimerObj({ isDisclaimerAccepted: false });
                
                setIsCardVerified(false);
                setIsIdVerificationCompleted(false);
                if (checkInConfigLocalCopy.idValidationInterface != "disabled") setCurrentPage(ID_VERIFICATION);
                else handleVerifyIdentityNext();
                break;
            case ID_VERIFICATION:
                if (checkInConfigLocalCopy.showAccompanyGuestIDPage) setCurrentPage(ACCOMPANY_GUEST_ID_VERIFICATION);
                else if (checkInConfigLocalCopy.showCardValidation) setCurrentPage(CARD_VALIDATION)
                else setCurrentPage(ADDITION_DETAILS)
                break;
            case ACCOMPANY_GUEST_ID_VERIFICATION:
                if (checkInConfigLocalCopy.showCardValidation) setCurrentPage(CARD_VALIDATION)
                else setCurrentPage(ADDITION_DETAILS)
                break;
            case CARD_VALIDATION:
                setCurrentPage(ADDITION_DETAILS);
                break;
            case ADDITION_DETAILS:
                if (checkInConfigLocalCopy.showAccompanyGuestDetailsPage) setCurrentPage(ACCOMPANY_GUEST_DETAILS);
                else setProceedToCheckIn(true);
                break;
            case ACCOMPANY_GUEST_DETAILS:
                // handle pre checkin
                setProceedToCheckIn(true);
                break;
            default:
                console.log('Invalid page');
        }
    };


    const handleGoBack = () => {
        console.log("handleGoBack called from:", currentPageRef.current);
        const page = currentPageRef.current;
        
        switch (page) {
            case (CHECKIN_GUIDE):
                // go home
                dispatch(setGoHome(true));
                break;
            case (BOOKING_INFO):
                // go home
                dispatch(setGoHome(true));
                break;
            case ID_VERIFICATION:
                dispatch(setGoHome(true));
                break;
            case ACCOMPANY_GUEST_ID_VERIFICATION:
                setCurrentPage(ID_VERIFICATION)
                break;
            case CARD_VALIDATION:
                if (checkInConfigLocalCopy.idValidationInterface != "disabled") {
                    setCurrentPage(ID_VERIFICATION)
                } else {
                    dispatch(setGoHome(true));
                }
                break;
            case ADDITION_DETAILS:
                if (checkInConfigLocalCopy.idValidationInterface != "disabled") {
                    setCurrentPage(ID_VERIFICATION)
                } else {
                    dispatch(setGoHome(true));
                }
                break;
            case ACCOMPANY_GUEST_DETAILS:
                setCurrentPage(ADDITION_DETAILS);
                break;
            case DISCLAIMER:
                if (checkInConfigLocalCopy.showAccompanyGuestDetailsPage) setCurrentPage(ACCOMPANY_GUEST_DETAILS);
                else setCurrentPage(ADDITION_DETAILS);
                break;
            default:
                console.log('Invalid page');
        }

        return true; // Tell BackHandler we handled it
    }

    const handleCancel = () => {
        dispatch(setGoHome(true));
    }




    const earlyCheckInConfirmFunc = (status) => {

        if(status){
            updateEarlyCheckInConfig({doEarlyCheckIn: true, askEarlyCheckIn: false});
            setProceedToCheckIn(true);
            dispatch(sendAnalytics(MOBILE_CHECKIN_CATEGORY, "EARLY CHECK-IN - ACCEPTED", { "element": "widget", "widgetSessionId": checkinSessionToken, "pageName": currentPage }));
        } else {
            dispatch(setGoHome(true));
            dispatch(sendAnalytics(MOBILE_CHECKIN_CATEGORY, "EARLY CHECK-IN - DECLINED", { "element": "widget", "widgetSessionId": checkinSessionToken, "pageName": currentPage }));
        }
    }


    const initiateBookingCache = async (idVerificationLocalMediaFiles = idVerificationMediaFiles) => {

        if (DEMO_FLOW_ENABLED || CHECKIN_DEMO_FLOW) {
            return { status: "SUCCESS" };
        }

        try {

            updateLoaderState(true, "Syncing booking details...")

            const sessionToken = await AsyncStorage.getItem("sessionToken");

            const formData = new FormData();
            formData.append("sessionToken", sessionToken);
            formData.append("lastName", guestdetails.lastName?.trim().toLowerCase());
            formData.append("checkinDate", guestdetails.checkinDate);
            formData.append("confirmationNumber", guestdetails.confirmationNumber?.trim() || "");
            formData.append("actionKey", "bookingEnquiry");

            if(earlyCheckInConfig.doEarlyCheckIn){
                formData.append("isEarlyCheckIn", true);
            }

            console.log(idVerificationLocalMediaFiles)
            if (checkInConfigLocalCopy.idValidationInterface != "disabled" && !preCheckInCompleted) {
                formData.append("docType", idVerificationLocalMediaFiles?.selectedIdType?.value);

                formData.append("image", await convertImageToBinaryBlob(idVerificationLocalMediaFiles.idImageUri), "guestid_front.jpg")
                idVerificationLocalMediaFiles.idImageBackUri && formData.append("image", await convertImageToBinaryBlob(idVerificationLocalMediaFiles.idImageBackUri), "guestid_back.jpg")

                formData.append("image", await convertImageToBinaryBlob(idVerificationLocalMediaFiles.selfieUri), "guestselfie.jpg");
            }

            !preCheckInCompleted && formData.append("checkInType", "precheckin");



            const headers = {
                headers: { 'Content-Type': 'multipart/form-data' }
            }

            const response = await clientConfigPath.post(
                `/mobileCheckIn/guestBooking`, formData, headers
            );

            updateLoaderState(false);

            if (response.data && response.data.payload) {
                dispatch(sendAnalytics(MOBILE_CHECKIN_CATEGORY, "BOOKING CACHE - SUCCESS", { "element": "widget", "widgetSessionId": checkinSessionToken, "pageName": currentPage }));
                return { status: "SUCCESS" };
            } else {

                if(response?.data?.header?.status?.isEarlyCheckInPossible){
                    dispatch(sendAnalytics(MOBILE_CHECKIN_CATEGORY, "EARLY CHECK-IN", { "element": "widget", "widgetSessionId": checkinSessionToken}));
                    if(mobileCheckInConfigs.earlyCheckInPopUpDisabled){
                        earlyCheckInConfirmFunc();
                      } else {
                        updateEarlyCheckInConfig({askEarlyCheckIn: true, message: response?.data?.header.status.msg});
                      }
                    return {status: "EARLYCHECKIN"};
                }

                // proceed to login
                if(response?.data?.header?.status?.guestCheckedIn && response?.data?.header?.status?.roomNumber){
                    dispatch(setProceedLoginToTheApp(true, { lastName:  guestdetails.lastName?.trim().toLowerCase(), confirmationNumber: guestdetails.confirmationNumber, checkinDate: guestdetails.checkinDate, roomNumber: response?.data?.header?.status?.roomNumber, candoAccompanyLogin: false, candoOtpFlow: false }));
                    return {status: "LINKTOROOM"};
                }

                const errorMessage = response?.data?.header.status.msg;
                dispatch(sendAnalytics(MOBILE_CHECKIN_CATEGORY, "BOOKING CACHE - FAILED", { "element": "widget", "widgetSessionId": checkinSessionToken, "pageName": currentPage, "errorMessage": errorMessage || "Something went wrong during bookingEnquiry call" }));

                updateEarlyCheckInConfig({doEarlyCheckIn: false});
                return { status: "FAILURE", message: errorMessage || "Something went wrong"};
            }
        } catch (error) {
            updateLoaderState(false);

            if(error?.response?.data?.header?.status?.isEarlyCheckInPossible){
                dispatch(sendAnalytics(MOBILE_CHECKIN_CATEGORY, "EARLY CHECK-IN", { "element": "widget", "widgetSessionId": checkinSessionToken}));
                if(mobileCheckInConfigs.earlyCheckInPopUpDisabled){
                    earlyCheckInConfirmFunc();
                  } else {
                    updateEarlyCheckInConfig({askEarlyCheckIn: true, message: error?.response?.data?.header.status.msg});
                  }
                return {status: "EARLYCHECKIN"};
            }

            // proceed to login
            if(error?.response?.data?.header?.status?.guestCheckedIn && error?.response?.data?.header?.status?.roomNumber){
                dispatch(setProceedLoginToTheApp(true, { lastName:  guestdetails.lastName?.trim().toLowerCase(), confirmationNumber: guestdetails.confirmationNumber, checkinDate: guestdetails.checkinDate, roomNumber: error?.response?.data?.header?.status?.roomNumber, candoAccompanyLogin: false, candoOtpFlow: false }));
                return {status: "LINKTOROOM"};
            }

            const errorMessage = error?.response?.data?.header?.status?.msg || error.message;
            dispatch(sendAnalytics(MOBILE_CHECKIN_CATEGORY, "BOOKING CACHE - FAILED", { "element": "widget", "widgetSessionId": checkinSessionToken, "pageName": currentPage, "errorMessage": errorMessage || "Something went wrong during bookingEnquiry call" }));

            updateEarlyCheckInConfig({doEarlyCheckIn: false});
            return { status: "FAILURE", message: errorMessage || "Something went wrong" };
        }
    }


    const handleAdditionDetailsNext = (updatedGuestDetails) => {

        console.log(updatedGuestDetails);
        const { lastName, ...restUpdatedGuestDetails } = updatedGuestDetails || {};

        restUpdatedGuestDetails.guestName && updateGuestDetails({ guestName: restUpdatedGuestDetails.guestName });
        restUpdatedGuestDetails.firstName && updateGuestDetails({ firstName: restUpdatedGuestDetails.firstName });
        restUpdatedGuestDetails.eta && updateGuestDetails({ checkInTime: restUpdatedGuestDetails.eta });
        restUpdatedGuestDetails.address && updateGuestDetails({ address: restUpdatedGuestDetails.address });
        restUpdatedGuestDetails.email && updateGuestDetails({ email: restUpdatedGuestDetails.email });
        restUpdatedGuestDetails.phone && updateGuestDetails({ phone: restUpdatedGuestDetails.phone });
        restUpdatedGuestDetails.birthDate && updateGuestDetails({ birthDate: restUpdatedGuestDetails.birthDate });

        updateGuestDetails({ extraData: restUpdatedGuestDetails });

        handleNextPage();
    }



    const handleCompanionGuestNext = (accompanyGuestData, accompanyGuestDetailsCompleted=true) => {

        console.log(accompanyGuestData);
        updateGuestDetails({accompanyGuestData, accompanyGuestDetailsCompleted});

        handleNextPage()
    }

    const handleCardValidationNext = (updatedGuestDetails) => {

        const { lastName, ...restUpdatedGuestDetails } = updatedGuestDetails || {};

        restUpdatedGuestDetails.firstName && updateGuestDetails({ firstName: restUpdatedGuestDetails.firstName });
        restUpdatedGuestDetails.address && updateGuestDetails({ address: {...guestdetails.address, ...restUpdatedGuestDetails.address} });

        handleNextPage();
    }


    const handleVerifyIdentityNext = async (idVerificationLocalMediaFiles = {}) => {

        const updatedFiles = { ...idVerificationMediaFiles, ...idVerificationLocalMediaFiles }
        setIsIdVerificationCompleted(true);
        setIdVerificationMediaFiles(updatedFiles);

        if (checkInConfigLocalCopy.showAccompanyGuestIDPage) {
            handleNextPage(ID_VERIFICATION);
        } else {
            const bookingCacheStatus = await initiateBookingCache(updatedFiles);

            if (bookingCacheStatus?.status == "SUCCESS") {
                handleNextPage(ID_VERIFICATION);
            } else {
                updateFetchApiError(true, bookingCacheStatus.message || "Something went wrong");
            }
        }
    }

    const handleIsBookingAvailable = async (data = {}) => {

        updateLoaderState(true, "Verifying booking details...")

       
        const { status, response, message } = await dispatch(checkBookingStatus(data, checkinSessionToken, currentPage));
        updateLoaderState(false);

        if (status == "SUCCESS") {
            // success is handled by useEffect;
        } else if(status == "FAILURE") {
            setIsConfirmationNumberMandatory(true);
            updateFetchApiError(true, message || "Booking not found with provided details.");
        }
    }


    useEffect(() => {
        if(currentPage == BOOKING_INFO){
            handleNextPage(BOOKING_INFO);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[guestdetails.bookingFoundLocalVar])

    useEffect(() => {

        if(isBookingFound){
            updateGuestDetails({bookingFoundLocalVar: true, accompanyGuestData: bookingData?.accompanyingGuestDetails || [], ...bookingData});

            if(supportedAccompanyGuestFlow.includes(checkInConfigLocalCopy.accompanyGuestApproach) && bookingData?.accompanyingGuestDetails?.length > 0){
                updateCheckInConfigLocalCopy({showAccompanyGuestDetailsPage: true});
            }
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[isBookingFound])





    const updatePreCheckinForm = async () => {
        const fetchedPreCheckinFormData = await fetchPreCheckinForm();

        setPreCheckInFormData(fetchedPreCheckinFormData);
    }

    const updateAccompanyGuestDetailsFormData = async () => {
        const response  = await getAccompanyguestDynamicBookingForm();
        setAccompanyGuestDetailsFormData(response);
    }
    


    const getCheckInConfig = async () => {

        setInitialLoader(true);

        dispatch(getDocumentList());
        dispatch(getCountryList());
        updatePreCheckinForm()
        updateAccompanyGuestDetailsFormData();

        const { success, data, message } = await fetchCheckInConfigs();
        setTimeout(() => setInitialLoader(false), 500);

        if (success) {
            console.log("Configs loaded:", data);

            if (data.cardValidationEnabled && supportedCardValidationFlow.includes(data.cardValidationInterface)) {
                data.showCardValidation = true;
            }

            updateCheckInConfigLocalCopy(data);
        } else {
            dispatch(setGoHome(true));
        }
    };

    useEffect(() => {
        if(checkInConfigLocalCopy?.skipGuideScreen && currentPage == CHECKIN_GUIDE){
            handleNextPage();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [checkInConfigLocalCopy?.skipGuideScreen])


    const verifyBookingStatus = async () => {
        updateLoaderState(true, "Verifying booking details...");
        const { status, response, message } = await dispatch(checkBookingStatus(bookingData, checkinSessionToken, currentPage));
        updateLoaderState(false);

        if (status == "SUCCESS") {
            // success is handled by useEffect;
        } else if(status == "FAILURE") {
            updateFetchApiError(true, message || "Someting went wrong", () => { updateFetchApiError(false); verifyBookingStatus()}, "Try again", () => dispatch(setGoHome(true)), "Close");
        }
    }

    useFocusEffect(useCallback(() => {
        const backHandler = BackHandler.addEventListener('hardwareBackPress', handleGoBack);
        return () => backHandler.remove();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[checkInConfigLocalCopy]))

    useEffect(() => {

        const { findMyRes } = route.params || {};

        if(!innspireOneConfigs?.api_url || !innspireOneConfigs?.api_key){
            updateFetchApiError(true, t("check_in.innspire_one_not_configured_message"), () => dispatch(setGoHome(true)));
            return;
        }

        if(isLoggedIn){
            updateFetchApiError(true, "You’re already checked in! You can now enjoy using the other app services.", () => dispatch(setGoHome(true)));
            return;
        }

        if(!preCheckInCompleted){
            getCheckInConfig();
        }

        if(isBookingFound) {
            verifyBookingStatus();
        }

        dispatch(sendAnalytics(MOBILE_CHECKIN_CATEGORY, CLICKED, { "element": "widget", "widgetSessionId": checkinSessionToken}));

        return () => {
            const widgetCloseTime = new Date;
            const widgetCloseDuration = calculateTimeDifference(widgetLaunchTime, widgetCloseTime, 'second');
            dispatch(sendAnalytics(MOBILE_CHECKIN_CATEGORY, EXIT, { "element": "widget", "widgetSessionId": checkinSessionToken, "duration": widgetCloseDuration}));
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])




    const handleDisclaimer = async (imageUri) => {
        try{
            let disclaimerFormData = new FormData();
            
            const sessionToken = await AsyncStorage.getItem("sessionToken");

            disclaimerFormData.append('sessionToken', sessionToken);
            disclaimerFormData.append('confirmationNumber', guestdetails.confirmationNumber?.trim());
            disclaimerFormData.append('reservationNumber', guestdetails.reservationNumber?.trim());

            disclaimerFormData.append('image', await convertImageToBinaryBlob(imageUri), "disclaimer.jpg");

            const headers = {
                headers: { 'Content-Type': 'multipart/form-data' }
            }
            
            updateLoaderState(true, "Please wait...")

            dispatch(sendAnalytics(MOBILE_CHECKIN_CATEGORY, "DISCLAIMER ACCEPTED", { "element": "widget", "widgetSessionId": checkinSessionToken, "pageName": currentPage }));

            const response = await clientConfigPath.post(
                `/mobileCheckIn/disclaimer`, 
                disclaimerFormData, 
                headers
            );

            updateLoaderState(false);
            dispatch(sendAnalytics(MOBILE_CHECKIN_CATEGORY, "DISCLAIMER SENT - SUCCESS", { "element": "widget", "widgetSessionId": checkinSessionToken, "pageName": currentPage }));

            handleGoBack();
            updateDisclaimerObj({ isDisclaimerAccepted: true });
            setProceedToCheckIn(true);
        } catch (error){
            console.log('Error in sending disclaimer: ', error);
            const errorMessage = error?.response?.data?.header?.status?.msg || error?.message || "Something went wrong";

            dispatch(sendAnalytics(MOBILE_CHECKIN_CATEGORY, "DISCLAIMER SENT - FAILED", { "element": "widget", "widgetSessionId": checkinSessionToken, "errorMessage": errorMessage, "pageName": currentPage }));
            updateLoaderState(false);
            updateFetchApiError(true, errorMessage);
        }
    }

    const getObject = (key) => {
        if (!idVerificationMediaFiles?.idImagesInfo?.idCardResponse){
            return null;
        }

        if(key=='raw_text'){
            let rawText = idVerificationMediaFiles.idImagesInfo.idCardResponse.raw_text ? idVerificationMediaFiles.idImagesInfo.idCardResponse.raw_text.join(",") : "";

        if(rawText !== "None" && rawText !== "none" && rawText !== "undefined"){
            return rawText;
        }
        }

        if(key=='idType'){
            let rawText = idVerificationMediaFiles.idImagesInfo.idCardResponse.type.name;

            if(rawText !== "None" && rawText !== "none" && rawText !== "undefined"){
                return rawText;
            }
        }

        let obj = {}
        for (obj of idVerificationMediaFiles.idImagesInfo.idCardResponse.fields){
            if (obj.key == key && obj.value !== "None" && obj.value !== "none" && obj.value !== "undefined"){
                return obj.value;
            }
        }
        return null;
    }

    const handleDisclaimerText = async () => {
        updateLoaderState(true, "Please wait...")
        try {
            const response = await getDisclaimerText(disclaimerObj.disclaimerType, disclaimerObj.langCode, guestdetails.reservationNumber);

            updateLoaderState(false);

            if(response.error) {
                updateFetchApiError(true, response.message);
                return;
            }

            const html = response?.data;
            if (!html) {
                updateFetchApiError(true, "Something went wrong");
                return;
            };

            const placeholders = {
                "#PASSPORTNUMBER": idVerificationMediaFiles?.selectedIdType?.key?.toLowerCase() == "passport" ? getObject("Id No.") : "",
                "#NATIONALITY": getObject("Nationality"),
                "#EMAIL": guestdetails.email,
                "#PHONE": guestdetails.phone,
                "#ADDRESSLINE1": guestdetails.address.addressLine1,
                "#ADDRESSLINE2": guestdetails.address.addressLine2,
                "#CITY": guestdetails.address.city,
                "#POSTALCODE": guestdetails.address.postalCode,
                "#FIRSTNAME": guestdetails.firstName,
                "#LASTNAME": guestdetails.lastName,
                "#GUESTNAME": guestdetails.firstName ? guestdetails.firstName + " " + guestdetails.lastName : guestdetails.lastName,
            };
            let tempText = html;
            Object.entries(placeholders).forEach(([key, value]) => {
                tempText = tempText.replace(new RegExp(key, 'g'), value || "");
            });
            updateDisclaimerObj({ disclaimerText: tempText });
            setCurrentPage(DISCLAIMER);
        } catch (error) {
            console.error(error);
            const errorMessage = error?.response?.data?.header?.status?.msg || error?.message || "Something went wrong";
            updateFetchApiError(true, errorMessage);
        }
    };

    const handleAdhocNext = () => {
        updateAdhochShown({renderAdhoc: false});
        setProceedToCheckIn(true)
    }



    useEffect(() => { 
        if(checkInConfigLocalCopy.disclaimerLanguageList && checkInConfigLocalCopy.disclaimerLanguageList.length > 0) {
            let found = false;
            checkInConfigLocalCopy.disclaimerLanguageList?.forEach((lang) => {
            if (lang.default) {
                found = true;
                updateDisclaimerObj({ langCode: lang.code });
            }
            });
            if (!found) updateDisclaimerObj({ langCode: "en" });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [checkInConfigLocalCopy.disclaimerLanguageList]);
    

    return (

        <>

            {
                isCheckInSuccess.status ?
                    <CheckInSuccess checkedInGuestDetails={isCheckInSuccess.guestDetails} />
                    : preCheckInCompleted ?
                        <PreCheckInSuccess checkinSessionToken={checkinSessionToken} handleProceedToCheckin={() => setProceedToCheckIn(true)} />

                        : <>
                            {currentPage == CHECKIN_GUIDE &&
                                <FadeTransition duration={10}>
                                <CheckInGuide
                                    idValidationEnabled={checkInConfigLocalCopy.idValidationInterface != "disabled"}
                                    accompanyGuestImagesFlowEnabled={checkInConfigLocalCopy.guestImagesCheckEnabled}
                                    cardValidationEnabled={checkInConfigLocalCopy.showCardValidation}
                                    accompanyGuestFlowEnabled={!checkInConfigLocalCopy.guestImagesCheckEnabled && checkInConfigLocalCopy.accompanyGuestApproach}
                                    handleGoBack={handleGoBack}
                                    handleNextPage={handleNextPage}
                                />
                                </FadeTransition>
                            }
                            {currentPage == BOOKING_INFO &&
                                <FadeTransition duration={100}>
                                <BookingInfo
                                    checkinSessionToken={checkinSessionToken}
                                    guestdetails={guestdetails}
                                    isConfirmationNumberMandatory={isConfirmationNumberMandatory}
                                    handleGoBack={handleGoBack}
                                    handleNext={handleIsBookingAvailable}
                                />
                                </FadeTransition>
                            }
                            {currentPage == ID_VERIFICATION &&
                                <FadeTransition duration={100}>
                                <VerifyIdentity
                                    checkinSessionToken={checkinSessionToken}
                                    lastName={guestdetails.lastName}
                                    confirmationNumber={guestdetails.confirmationNumber}
                                    disableLivelinessCheck={checkInConfigLocalCopy.disableLivelinessCheck}
                                    isIdVerificationCompleted={isIdVerificationCompleted}
                                    setIsIdVerificationCompleted={setIsIdVerificationCompleted}
                                    idVerificationMediaFiles={idVerificationMediaFiles}
                                    handleGoBack={null}
                                    handleCancel={()=> setCancel(true)}
                                    handleNext={handleVerifyIdentityNext}
                                    handleSkip={handleNextPage}
                                />
                                </FadeTransition>
                            }

                            {/* // Accompany Guest Id Verification */}

                            {/* // Card Validation */}
                            {currentPage == CARD_VALIDATION && 
                                <FadeTransition duration={100}>
                                <CardValidation
                                    checkinSessionToken={checkinSessionToken}
                                    cardValidationInterface={checkInConfigLocalCopy.cardValidationInterface}
                                    guestValidationMaxRetry={checkInConfigLocalCopy.guestValidationMaxRetry}
                                    isCardVerified={isCardVerified}
                                    guestDetails={guestdetails}
                                    handleGoBack={handleGoBack}
                                    handleCancel={()=> setCancel(true)}
                                    handleNext={handleCardValidationNext}
                                    handleSetCardVerified={() => setIsCardVerified(true)}
                                    handleSkip={handleNextPage}
                                />
                                </FadeTransition>
                            }


                            {currentPage == ADDITION_DETAILS &&
                                <FadeTransition duration={100}>
                                <AdditionalDetails
                                    checkinSessionToken={checkinSessionToken}
                                    dynamicFormData={preCheckinFormData}
                                    guestDetails={guestdetails}
                                    handleNext={handleAdditionDetailsNext}
                                    handleGoBack={handleGoBack}
                                    handleCancel={()=> setCancel(true)}
                                    primaryBtnTxt={checkInConfigLocalCopy.showAccompanyGuestDetailsPage ? "Next" : preCheckInWidgetState == PRE_CHECKIN ? t('check_in.pre_checkin_button') : t('check_in.checkin_button')}
                                    secondaryBtnTxt={t('check_in.back')}
                                />
                                </FadeTransition>
                            }


                            {/* // Accompany Guest Details */}
                            {currentPage == ACCOMPANY_GUEST_DETAILS && ( 
                                checkInConfigLocalCopy.accompanyGuestApproach === "guestNames" ? 
                                <FadeTransition duration={100}>
                                <AccompanyingGuestDetailsInput 
                                    accompanyGuests={guestdetails.accompanyGuestData}
                                    checkinSessionToken={checkinSessionToken}
                                    handleNext={handleCompanionGuestNext}
                                    handleGoBack={handleGoBack}
                                    handleCancel={()=> setCancel(true)}
                                    primaryBtnTxt={preCheckInWidgetState == PRE_CHECKIN ? t('check_in.pre_checkin_button') : t('check_in.checkin_button')}
                                    secondaryBtnTxt={t('check_in.back')}

                                    setError={updateFetchApiError}
                                /> 
                                </FadeTransition>
                                :
                                checkInConfigLocalCopy.accompanyGuestApproach === "dynamicGuestInfo" ? 
                                <AccompanyGuestDetails 
                                    accompanyGuests={guestdetails.accompanyGuestData}
                                    accompanyGuestDetailsCompleted={guestdetails.accompanyGuestDetailsCompleted}
                                    dynamicFormData={accompanyGuestDetailsFormData}
                                    checkinSessionToken={checkinSessionToken}
                                    handleNext={handleCompanionGuestNext}
                                    handleGoBack={handleGoBack}
                                    handleCancel={()=> setCancel(true)}
                                    primaryBtnTxt={preCheckInWidgetState == PRE_CHECKIN ? t('check_in.pre_checkin_button') : t('check_in.checkin_button')}
                                    secondaryBtnTxt={t('check_in.back')}
                                /> : 
                                checkInConfigLocalCopy.accompanyGuestApproach === "freeformAdd" ?
                                    null
                                : null
                            )}




                            {currentPage == DISCLAIMER && 
                                <FadeTransition duration={100}>
                                <Disclaimer 
                                    disclaimerText={disclaimerObj.disclaimerText}
                                    guestdetails={guestdetails} 
                                    updateLoaderState={updateLoaderState}
                                    checkInConfigLocalCopy={checkInConfigLocalCopy}
                                    handleNext={(disclaimerSS) => handleDisclaimer(disclaimerSS)}
                                    handleGoBack={handleGoBack}
                                    updateFetchApiError={updateFetchApiError}
                                />
                                </FadeTransition>
                            }

                            {showAdhocItem.renderAdhoc && 
                                <AdhocPage
                                    adhocList={adhocDataList}
                                    handleNext={handleAdhocNext}
                                />
                            }
                        </>
            }

            {initialLoder && getDataLoadingScreen(INITIAL_LOADER_SCREEN)}
            {loaderState.isVisible && <FetchingDataScreen loaderMessage={loaderState.message} />}

            {fetchApiError.errorStatus && 
            <InfoPopupModal 
                subtitle={fetchApiError.errorMessage} 
                onContinue={fetchApiError.onContinueFunc ? fetchApiError.onContinueFunc : () => updateFetchApiError(false)}
                primaryBtnLabel={fetchApiError.primaryBtnLabel ? fetchApiError.primaryBtnLabel : "Close"} 
                onClose={fetchApiError.onCloseFunc ? fetchApiError.onCloseFunc : null}
                secondaryBtnLabel={fetchApiError.secondaryBtnLabel ? fetchApiError.secondaryBtnLabel : null}
                OnRequestClose={fetchApiError.onCloseFunc ? fetchApiError.onCloseFunc : () => updateFetchApiError(false)}
            />}

            {earlyCheckInConfig.askEarlyCheckIn && 
                <InfoPopupModal
                    title={"Attention!"}
                    subtitle={(earlyCheckInConfig.message || '') + t('check_in.earlyCheckin_proceed')}
                    onClose={() => earlyCheckInConfirmFunc(false)}
                    secondaryBtnLabel={"No"}
                    onContinue={() => earlyCheckInConfirmFunc(true)}
                    primaryBtnLabel={"Yes"}
                /> 
            }

            {cancel && <InfoPopupModal 
                title={t('check_in.cancel_heading')}
                subtitle={t('check_in.cancel_subheading')}
                onClose={() => setCancel(false)}
                secondaryBtnLabel={"No"}
                OnRequestClose={() => setCancel(false)}
                onContinue={() => handleCancel(true)}
                primaryBtnLabel={"Yes"}
            />}
        </>
    )

}